import React from "react";
import { RiEyeCloseLine, RiEyeLine } from "react-icons/ri";
import { useToggle } from "usehooks-ts";
import { Input, InputProps } from "./Input";
import { useTranslations } from "../contexts";

type PasswordInputProps = InputProps;

export const PasswordInput: React.FC<PasswordInputProps> = (props) => {
  const [showPassword, toggleShowPassword] = useToggle(false);
  const i18n = useTranslations();
  return (
    <div className="relative">
      <Input
        type={showPassword ? "text" : "password"}
        {...props}
        placeholder={i18n.password}
      />
      <div
        className="absolute top-1/2 right-3 transform -translate-y-1/2 cursor-pointer"
        onClick={() => toggleShowPassword()}
      >
        {showPassword ? <RiEyeLine size={20} /> : <RiEyeCloseLine size={20} />}
      </div>
    </div>
  );
};
